module.exports = __webpack_public_path__ + "static/img/wawa3.9d42039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawa3.png
// module id = Rwnh
// module chunks = 2